module.exports = __webpack_public_path__ + "static/media/key.afdc42b5.jpg";